import { render, staticRenderFns } from "./AverageCompletionDashboard.vue?vue&type=template&id=b08909ce&scoped=true"
import script from "./AverageCompletionDashboard.vue?vue&type=script&lang=js"
export * from "./AverageCompletionDashboard.vue?vue&type=script&lang=js"
import style1 from "./AverageCompletionDashboard.vue?vue&type=style&index=1&id=b08909ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08909ce",
  null
  
)

export default component.exports